import {charcoal} from '../../sass/v2/_exports.sass';

export const ContactsIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.1387 14.7306C22.9507 13.3467 23.3014 11.7404 23.14 10.144C22.9014 7.76529 21.5734 5.66263 19.4027 4.22396L17.9294 6.44529C19.4214 7.43463 20.3294 8.84396 20.4867 10.4106C20.5592 11.1388 20.4686 11.8739 20.2213 12.5626C19.9741 13.2513 19.5765 13.8762 19.0574 14.392L17.468 15.9813L19.6254 16.6146C25.268 18.268 25.3334 23.9426 25.3334 24H28C28 21.6146 26.7254 16.9533 22.1387 14.7306Z"
        fill={color}
      />
      <path
        d="M12.6667 16C15.608 16 18 13.608 18 10.6667C18 7.72534 15.608 5.33334 12.6667 5.33334C9.72533 5.33334 7.33333 7.72534 7.33333 10.6667C7.33333 13.608 9.72533 16 12.6667 16ZM12.6667 8C14.1373 8 15.3333 9.196 15.3333 10.6667C15.3333 12.1373 14.1373 13.3333 12.6667 13.3333C11.196 13.3333 10 12.1373 10 10.6667C10 9.196 11.196 8 12.6667 8ZM14.6667 17.3333H10.6667C6.25467 17.3333 2.66667 20.9213 2.66667 25.3333V26.6667H5.33333V25.3333C5.33333 22.392 7.72533 20 10.6667 20H14.6667C17.608 20 20 22.392 20 25.3333V26.6667H22.6667V25.3333C22.6667 20.9213 19.0787 17.3333 14.6667 17.3333Z"
        fill={color}
      />
    </svg>
  );
};
